import {
  TranslationsContext
} from "./chunk-SKR5AE4Z.mjs";

// src/multiselect/src/components/translations-context/useTranslationsContext.ts
import { useContext } from "react";
function useTranslationsContext() {
  return useContext(TranslationsContext);
}

export {
  useTranslationsContext
};
